module.exports = __webpack_public_path__ + "img/mjq.5ef321b5.png";